export const muiStyles = () => ({
    root: { flexGrow: 1 },
    noSelectedConnection: {
        paddingTop: '3rem',
        alignSelf: 'center' as const,
        justifySelf: 'center' as const
    },
    apiIcon: {
        height: '90px',
        width: '90px',
        paddingBottom: '.5rem'
    }
});